<template>
	<div class="fin-border fin-rounded fin-p-5 fin-bg-white">
		<h3 class="mb-2">Comprehensive Insurance Options</h3>
        
		<p>
			Functionality to activate the Comprehensive Insurance Consent at Conditioning. Leaving an option blank will match on all items.
		</p>

		<el-form class="mt-4" ref="optionForm" :model="options" label-position="top">
			<small>
				Application type, asset type, and loan type determines if the insurance consent screen is activated at Conditioning
			</small>
			<el-row :gutter="10">
				<el-col :span="8">
					<el-form-item label="Application Type/s">
						<el-select
							@change="saveOptions"
							:loading="_.isEmpty(optionData)"
							class="w-100"
							collapse-tags
							multiple
							filterable
							clearable
							v-model="options.application_types"
							placeholder="Application Type/s"
						>
							<el-option
								v-for="item in optionData.applicationTypes"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="Asset Type/s">
						<el-select
							@change="saveOptions"
							:loading="_.isEmpty(optionData)"
							class="w-100"
							collapse-tags
							multiple
							filterable
							clearable
							v-model="options.asset_types"
							placeholder="Asset Type/s"
						>
							<el-option v-for="item in optionData.assetTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="Loan Type/s">
						<el-select
							@change="saveOptions"
							:loading="_.isEmpty(optionData)"
							class="w-100"
							collapse-tags
							multiple
							filterable
							clearable
							v-model="options.loan_types"
							placeholder="Loan Type/s"
						>
							<el-option v-for="item in optionData.loanTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>

			<small>If the above matches the application and the consent is rejected, the below insurers will not show.</small>
			<el-row :gutter="10">
				<el-col :span="8">
					<el-form-item label="Insurers">
						<el-select
							@change="saveOptions"
							:loading="_.isEmpty(optionData)"
							class="w-100"
							collapse-tags
							multiple
							filterable
							clearable
							v-model="options.insurers"
							placeholder="Insurer/s"
						>
							<el-option v-for="item in optionData.insurers" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
                <el-col :span="16" v-if="options.id && !_.isNull(options.tenant_id) && showRevert">
                    <el-form-item label="Revert to Default">
						<el-button @click="revertOptions" type="primary">Revert Options</el-button>
					</el-form-item>
                </el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: "ComprehensiveInsuranceOptions",

		data() {
			return {
                default: {},
				options: {},
				optionData: [],
				abortController: null,
                showRevert: false,
			}
		},

		mounted() {
			this.getOptionData()
		},

		methods: {
			getOptionData() {
				axios
					.post("/admin/comprehensive-insurance-options/get-option-data")
					.then((res) => {
						this.optionData = res.data.optionData
						this.options = !_.isNull(res.data.options) ? res.data.options : {}
						this.default = !_.isNull(res.data.default) ? res.data.default : {}
                        this.showRevert = !_.isNull(this.options.tenant_id) ? true : false
					})
					.catch((err) => {
						console.error(err)
					})
			},
            revertOptions() {
                this.options = this.default
                this.showRevert = false
                axios
					.post("/admin/comprehensive-insurance-options/revert-options")
					.catch((err) => {
						console.error(err)
					})
            },
			cancelSave() {
				if (this.abortController) {
					this.abortController.abort()
				}
			},
			saveOptions() {
				this.cancelSave()
				this.abortController = new AbortController();
				this.commitSave()
			},
			commitSave() {
				axios
					.post("/admin/comprehensive-insurance-options/save-options", this.options, {
						signal: this.abortController.signal
					})
					.then((res) => {
                        this.options = res.data
                        this.showRevert = true
                    })
					.catch((err) => {
						if (!axios.isCancel(err)) {
							console.error(err)
						}
					})
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
